import { Tooltip as TooltipPrimitive } from 'radix-ui';
import type { ComponentProps } from 'react';

export const TooltipProvider = TooltipPrimitive.Provider;
export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;
export const TooltipPortal = TooltipPrimitive.Portal;
export const TooltipContent = TooltipPrimitive.Content;
export const TooltipArrow = TooltipPrimitive.Arrow;

export type TooltipProviderProps = ComponentProps<typeof TooltipPrimitive.Provider>;
export type TooltipProps = ComponentProps<typeof TooltipPrimitive.Root>;
export type TooltipTriggerProps = ComponentProps<typeof TooltipPrimitive.Trigger>;
export type TooltipContentProps = ComponentProps<typeof TooltipPrimitive.Content>;
export type TooltipArrowProps = ComponentProps<typeof TooltipPrimitive.Arrow>;
